import { theme } from '../../theme';

export const selectWrapper = {
  display: 'flex',
  flexDirection: 'column',
  gap: '28px',
  '& label.Mui-focused': {
    color: 'black',
  },
  '& .MuiSvgIcon-root': {
    color: '#6CA370',
  },
  '& .MuiFormHelperText-root': {
    width: '300px',
  },
};

export const selectErrorWrapper = {
  color: '#d32f2f',
};

export const chipsItem = {
  display: 'flex',
  flexWrap: 'wrap',
  flexDirection: 'row-reverse',
  justifyContent: 'center',
  '& .MuiChip-root': {
    padding: '12px',
    gap: '8px',
  },
  '& .MuiSvgIcon-root': {
    margin: 0,
  },
};

export const chipsWrapper = {
  display: 'flex',
  gap: '4px',
  mt: '8px',
  flexWrap: 'wrap',
};

export const chipSize = {
  fontSize: '14px',
  color: theme.darkGreen,
  background: '#E6F4E7',
  '& .MuiChip-label': {
    padding: 0,
  },
  '& .MuiChip-deleteIcon': {
    color: theme.darkGreen,
  },
};

export const errorBlock = {
  marginTop: 7.5,
  position: 'absolute',
  width: 300,
};

export const formControl = {
  position: 'relative',
};
